import './Project.css'
import React from 'react';
import { Link } from 'react-router-dom';


const Project = ({ id, img, title, subTitle, des, live }) => {
    return (
        <div className='project' >
            <div
                style={{
                    background: `url('${img}')`,
                    backgroundSize: 'cover'
                }}
                className="project-img">
            </div>
            <div className="project-info">
                <p>
                    <span className='title'>{title} </span>
                    -- <i>{subTitle}</i>
                </p>
                <div className="actions">
                    <Link to={`/projects/${id}`}>See Details</Link>
                    <a href={live} target="_blank" rel="noopener noreferrer">Live Site</a>

                </div>
            </div>
        </div>
    );
};

export default Project;